export default __webpack_public_path__ + "static/media/acquisitionProgram.ddb0ed85.png";